<template>
    <button :class="isDisabled ? 'disabled cursor-default opacity-75' : ''" :type="type" :disabled="isDisabled">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" v-if="loading"></span>
        <span v-if="loading && state">{{ state }}</span>
        <slot v-else />
    </button>
</template>

<script>
export default {
    props: ['type', 'loading', 'state', 'disabled'],
    computed: {
        isDisabled() {
            return this.loading || this.disabled;
        }
    }
}
</script>